// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Calendar = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M61.952 27.005v-11.96a1.994 1.994 0 0 0-3.986 0v11.96a1.993 1.993 0 0 0 3.986 0m-23.917 0v-11.96a1.994 1.994 0 0 0-3.986 0v11.96a1.993 1.993 0 0 0 3.986 0m16.08-5.98a2.128 2.128 0 0 0-2.128-2.128h-7.973a2.13 2.13 0 1 0 0 4.257h7.973a2.128 2.128 0 0 0 2.128-2.129m26.591 61.922H15.293A6.8 6.8 0 0 1 8.5 76.155V25.689a6.8 6.8 0 0 1 6.793-6.792h12.776a2.129 2.129 0 0 1 0 4.257H15.293a2.538 2.538 0 0 0-2.535 2.535v50.466a2.538 2.538 0 0 0 2.535 2.535h65.413c1.4 0 2.537-1.137 2.537-2.535V25.689a2.538 2.538 0 0 0-2.537-2.535H67.932a2.128 2.128 0 1 1 0-4.257h12.774a6.8 6.8 0 0 1 6.794 6.792v50.466a6.8 6.8 0 0 1-6.794 6.792"
			fillRule="evenodd"
		/>
	</svg>
);
export default Calendar;
